import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EditAssumptionsHeaderProps {
  onBack: () => void;
}

export function EditAssumptionsHeader({ onBack }: EditAssumptionsHeaderProps) {
  return (
    <div className="border-b bg-white px-4 py-4 md:px-8">
      <div className="mx-auto flex max-w-4xl items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="gap-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Button>
        <div>
          <h1 className="text-xl font-semibold text-gray-900">Edit Assumptions</h1>
          <p className="text-sm text-gray-600">Customize your care cost projections</p>
        </div>
      </div>
    </div>
  );
}
